import { t } from '@lingui/core/macro';
export const getGenericRequiredFieldMsg = (): string =>
  t`A required field needs input.`;
export const TOOLTIP_ERROR_LIST_CLASS = 'tooltip-error-list';
